import {Component} from '@angular/core';
import {KeycloakService} from '../../../core/auth/keycloak.service';

@Component({
    selector: 'smart-dropdown-user',
    templateUrl: './dropdown-user.component.html',
})
export class DropdownUserComponent {


    user = {
        user: 'mohammad khaleel',
        app: 'SmartAdmin',
        name: 'mohammad khaleel',
        email: 'mohammad.jebreen@progressoft.com',
        avatar: 'avatar-admin.png',
    };
    currentDate: Date;

    logout() {
        KeycloakService.logout();
    }

    constructor() {
        this.currentDate = new Date();
    }
}
